export default __webpack_public_path__ + "static/media/iconWhatsapp.1dd8ca27.png";